// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-box[data-v-a3ecfba6]{margin:0;padding:11px 15px;border-radius:5px;border:1px solid #f8e9e9;background-color:#fff7dd}", ""]);
// Exports
module.exports = exports;
